import axiosInstance from "../../../axios/axiosUmbraco";
import { formatDateArray } from "../../../helper/formatDateArray";

export function getCourses() {
    return new Promise((resolve, reject) => {
        const id = process.env.REACT_APP_UMBRACO_EAHS_LIBRARY;
        const baseURL = process.env.REACT_APP_UMBRACO;
        axiosInstance.get(`/umbraco/delivery/api/v1/content?fetch=${id}&sort=sortOrder:desc&skip=0&take=20000`).then(response => {
            const res = response?.data?.items ?? [];
            const formattedData = res.map((x) => ({
                title: x?.properties?.title ?? '',
                subtitle: x?.properties?.subtitle ?? '',
                dipslayDate: formatDateArray(x?.properties?.publishDate),
                publishDate: x?.properties?.publishDate,
                image: x?.properties?.image?.length > 0 ? baseURL + x?.properties?.image[0].url : '',
                attatchment: x?.properties?.attatchment?.length > 0 ? baseURL + x?.properties?.attatchment[0].url : '',
                category: x?.properties?.category?.items?.length > 0 ? x?.properties?.category?.items?.map((cat) => (
                     cat?.content?.properties?.serviceCategoryName
                )) : []

            }))
            resolve(formattedData ?? []);
        }).catch(error => {
            console.error(error);
            reject(false);
        }
        )
    })
}